var barcodes = {};
export {
  barcodes as __exports
};
//# sourceMappingURL=index135.js.map
